import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import { fetchUbpEnablement } from './fetchUbpEnablement.tsx';
import type { UbpEnablementData } from './UbpEnablementData.types.tsx';

const RESOURCE_TYPE_UBP_ENABLEMENT = 'UBP_ENABLEMENT';

export const ubpEnablementResource: RouteResource<UbpEnablementData> =
	createResource<UbpEnablementData>({
		type: RESOURCE_TYPE_UBP_ENABLEMENT,
		getKey: () => RESOURCE_TYPE_UBP_ENABLEMENT,
		getData: () => fetchUbpEnablement(),
		maxAge: 60 * 60 * 1000, // 1 hour
	});

export const useUbpEnablementResource = (): UseResourceHookResponse<UbpEnablementData> =>
	useResource(ubpEnablementResource);
